export enum WixFormDatahooks {
  Main = 'wix-forms-main',
}
